export enum SignUpType {
  phone,
  email,
  both
}
